<template>
  <div class="image-zoom">
    <button type="button" @click="zoom">
      <img :src="preview" :alt="alt" />
      <span class="icon icon-expand"></span>
    </button>
    <a11y-dialog
      v-if="isZoomed"
      :id="`zoom-${_uid}`"
      dialog-root="#dialog-root"
      app-root="[data-award-detail]"
      :close-button-label="translate('lblDialogClose')"
      :disable-native="true"
      @dialog-ref="assignDialogRef"
      :class-names="classNames"
    >
      <template v-slot:closeButtonContent>
        <icon-close></icon-close>
      </template>

      <img :src="zoomed" :alt="alt" />
    </a11y-dialog>
  </div>
</template>

<script>
import { A11yDialog } from 'vue-a11y-dialog';
import IconClose from '../../shared/components/icons/Close.vue';

export default {
  name: 'ImageZoom',
  data: () => ({
    dialog: null,
    isZoomed: false,
  }),
  props: {
    preview: {
      type: String,
      required: true,
    },
    zoomed: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      required: true,
    },
  },
  computed: {
    classNames() {
      return {
        element: 'image-zoom-container',
        overlay: 'image-zoom-overlay',
      };
    },
  },
  methods: {
    wrapInto(toBeWrapped, className) {
      const { parentElement } = toBeWrapped;
      this.ctrlsContainer = document.createElement('div');
      this.ctrlsContainer.classList.add(className);
      this.ctrlsContainer.prepend(toBeWrapped);
      parentElement.prepend(this.ctrlsContainer);
    },
    adjustImageHeight(content) {
      if (content.querySelector('.mfp-img')) {
        const controlsHeight = content.querySelector('.gallery-controls').offsetHeight;
        const textHeight = content.querySelector('.mfp-bottom-bar').offsetHeight;
        const imageHeight = window.innerHeight - (controlsHeight + textHeight + 40);
        // eslint-disable-next-line no-param-reassign
        content.querySelector('.mfp-img').style.maxHeight = `${imageHeight}px`;
      }
    },
    zoom() {
      this.isZoomed = true;
    },
    closeDialog() {
      this.isZoomed = false;
    },
    assignDialogRef(dialog) {
      if (dialog) {
        this.dialog = dialog;
        this.dialog.on('hide', () => {
          this.closeDialog();
        });
        this.dialog.show();
      }
    },
  },
  components: {
    A11yDialog,
    IconClose,
  },
};
</script>

<style lang="scss">
.image-zoom button {
  all: unset;
  cursor: pointer;
  position: relative;
}

.vue-portal-target {

  .image-zoom-container,
  .image-zoom-overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .image-zoom-overlay {
    background-color: rgba(11, 11, 11, .8);
    z-index: 2000;
  }

  .image-zoom-container {
    z-index: 2001;
    pointer-events: none;
    display: flex;
    align-items: center;

    [role='document'] {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      width: fit-content;
      margin: 0 auto;

      h1 {
        display: none;
      }

      img {
        flex-shrink: 1;
        max-width: 100%;
        max-height: calc(100vh - (2 * #{rem($main-padding-s)}));

        @include media-breakpoint-up(m) {
          max-width: calc(100vw - (2 * #{rem($main-padding-m)}));
          max-height: calc(100vh - (2 * #{rem($main-padding-m)}));
        }
        @include media-breakpoint-up(l) {
          max-width: calc(100vw - (2 * #{rem($main-padding-l)}));
          max-height: calc(100vh - (2 * #{rem($main-padding-l)}));
        }
      }

      [data-a11y-dialog-hide] {
        width: rem(20px);
        height: rem(30px);
        padding: 0 0 10px 0;;

        cursor: pointer;
        background: transparent;
        border: 0;
        appearance: none;
        opacity: .75;

        svg {
          fill: $color-white;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
